import React, { useState } from "react";
import { Button, Divider, Table, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styles from "../styles/machineTable.module.css";
import { SyncOutlined } from "@ant-design/icons";
import { machineTableCols } from "../utils/machineTableUtils";
import ResizableTitle from "./resize";

export default function MachineBody(props) {
  const {
    machinesData,
    loading,
    totalRecords,
    onTableChange,
    setShowModal,
    setIsEdit,
    currentPage,
    onRefresh,
    onMachineClick,
    currentPageSize,
    onPaginationChange,
  } = props;

  const [columns, setColumns] = useState(
    machineTableCols(onMachineClick, setShowModal)
  );

  const handleResize =
    (index) =>
    (_, { size }) => {
      const newColumns = [...columns];
      newColumns[index] = {
        ...newColumns[index],
        width: size.width,
      };
      setColumns(newColumns);
    };
  const mergeColumns = columns.map((col, index) => ({
    ...col,
    onHeaderCell: (column) => ({
      width: column.width,
      onResize: handleResize(index),
      minWidth: column.minWidth,
    }),
  }));

  return (
    <>
      <div>
        <div className={styles.containerHeader}>
          <div className={styles.containerHeaderCol1}>
            <span style={{ fontWeight: "bold" }}>Machines</span>{" "}
            <span className={styles.containerHeaderCol1Span}>
              ({totalRecords})
            </span>
          </div>
          <div className={styles.containerHeaderCol2}>
            <Tooltip title="Refresh">
              <Button
                icon={<SyncOutlined spin={loading} tool />}
                onClick={onRefresh}
                disabled={loading}
              />
            </Tooltip>
            <Divider type="vertical" />
            <Tooltip>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setShowModal(true);
                  setIsEdit(false);
                }}
              >
                New Machine
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className={styles.containerBody}>
          <Table
            bordered
            size="small"
            loading={loading}
            onChange={onTableChange}
            columns={mergeColumns}
            dataSource={machinesData}
            pagination={{
              pageSize: currentPageSize,
              total: totalRecords,
              current: currentPage,
              showSizeChanger: true,
              onChange: onPaginationChange,
            }}
            components={{
              header: {
                cell: ResizableTitle,
              },
            }}
            scroll={{ x: 1200, y: 500 }}
          />
        </div>
      </div>
    </>
  );
}
